<template>
  <div class="language">
    <div class="page-header">
      <h1>{{ $t('common.language') }}</h1>
    </div>
    <Card shadow>
      <RadioGroup v-model="currentLang">
        <Radio v-for="lang in LANG_LIST" :key="lang.value" :label="lang.value">
          <span>{{ lang.label }}</span>
        </Radio>
      </RadioGroup>
      <div class="oper-col">
        <Button type="primary" @click="submitLang">{{ $t('common.submit') }}</Button>
      </div>
    </Card>
  </div>
</template>

<script>
import { LANG_LIST } from '@/utils/constants'
import currentLang from '@/mixins/currentLang'

export default {
  name: 'Language',

  mixins: [currentLang],

  data() {
    return {
      LANG_LIST,
      currentLang: LANG_LIST[0].value,
    }
  },

  created() {
    this.currentLang = this.lang
    this.setHtmlLangAttr(this.currentLang)
  },

  methods: {
    setHtmlLangAttr(lang) {
      document.querySelector('html').setAttribute('lang', lang)
    },
    submitLang() {
      if (this.currentLang === this.lang) {
        return
      }
      this.setHtmlLangAttr(this.currentLang)
      this.$store.dispatch('SET_LANGUAGE', this.currentLang)
    },
  },
}
</script>

<style lang="scss">
.language {
  .oper-col {
    margin-top: 40px;
    margin-bottom: 10px;
  }
  .ivu-radio-group {
    font-size: 18px;
  }
  .ivu-radio-wrapper {
    margin-right: 40px;
  }
}
</style>
